// extracted by mini-css-extract-plugin
module.exports = {"container":"EventSnapshotItem_container__2M5Fw","note":"EventSnapshotItem_note__3ZR_s","null":"EventSnapshotItem_null__2oo7t","detailsBtn":"EventSnapshotItem_detailsBtn__3TT5R"};